import { useState, useEffect } from "react";

const DEFAULT_FORM = {
  name: "",
  url: "",
  width: "",
  height: "",
  durationSeconds: "",
};

const toFormState = (creative) => {
  if (!creative) return { ...DEFAULT_FORM };
  return {
    name: creative.name ?? "",
    url: creative.url ?? "",
    width: creative.width != null ? String(creative.width) : "",
    height: creative.height != null ? String(creative.height) : "",
    durationSeconds:
      creative.durationSeconds != null ? String(creative.durationSeconds) : "",
  };
};

export default function CreativeForm({ initialCreative, onSubmit, onCancel }) {
  const [form, setForm] = useState(() => toFormState(initialCreative));
  const [error, setError] = useState("");

  useEffect(() => {
    setForm(toFormState(initialCreative));
    setError("");
  }, [initialCreative]);

  const handleField = (field, value) =>
    setForm((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.url.trim()) {
      setError("URL is required");
      return;
    }
    try {
      new URL(form.url.trim());
    } catch {
      setError("Please enter a valid URL (including https://)");
      return;
    }
    setError("");

    const toPositiveInt = (v) => {
      const n = parseInt(v, 10);
      return Number.isFinite(n) && n > 0 ? n : null;
    };

    const payload = { url: form.url.trim() };
    const name = form.name.trim();
    const width = toPositiveInt(form.width);
    const height = toPositiveInt(form.height);
    const durationSeconds = toPositiveInt(form.durationSeconds);
    if (name) payload.name = name;
    if (width != null) payload.width = width;
    if (height != null) payload.height = height;
    if (durationSeconds != null) payload.durationSeconds = durationSeconds;

    onSubmit(payload);
  };

  return (
    <form className="builder-form" onSubmit={handleSubmit}>
      {error && (
        <div className="form-error" style={{ marginBottom: "1rem" }}>
          {error}
        </div>
      )}

      <div className="form-group-modal">
        <label htmlFor="creative-name">Name (optional)</label>
        <input
          id="creative-name"
          value={form.name}
          onChange={(e) => handleField("name", e.target.value)}
          placeholder="e.g. Spring banner 1080p"
        />
      </div>

      <div className="form-group-modal">
        <label htmlFor="creative-url">URL *</label>
        <input
          id="creative-url"
          value={form.url}
          onChange={(e) => handleField("url", e.target.value)}
          placeholder="https://cdn.example.com/ad.mp4"
          required
        />
      </div>

      <div className="builder-grid three-columns">
        <div className="form-group-modal">
          <label htmlFor="creative-duration">Duration (s)</label>
          <input
            id="creative-duration"
            type="number"
            min="1"
            value={form.durationSeconds}
            onChange={(e) => handleField("durationSeconds", e.target.value)}
            placeholder="e.g. 30"
          />
        </div>
        <div className="form-group-modal">
          <label htmlFor="creative-width">Width (px)</label>
          <input
            id="creative-width"
            type="number"
            min="1"
            value={form.width}
            onChange={(e) => handleField("width", e.target.value)}
            placeholder="e.g. 1920"
          />
        </div>
        <div className="form-group-modal">
          <label htmlFor="creative-height">Height (px)</label>
          <input
            id="creative-height"
            type="number"
            min="1"
            value={form.height}
            onChange={(e) => handleField("height", e.target.value)}
            placeholder="e.g. 1080"
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "0.75rem",
          justifyContent: "flex-end",
          marginTop: "1.5rem",
        }}
      >
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="btn btn-primary">
          {initialCreative ? "Save Changes" : "Create Creative"}
        </button>
      </div>
    </form>
  );
}
